export const colors = {
  brandPrimaryDefault: "#2B90FF",
  brandPrimaryTint: "#99CAFF",
  brandPrimaryShade: "#003D81",
  contentStrong: "#ffffff",
  contentDefault: "#CED4DB",
  contentSubtle: "#969DA3",
  contentDisabled: "#ffffff33",
  contentOnLight: "#011638",
  contentBrandPrimary: "#2B90FF",
  contentBrandSecondary: "#C6D3E1",
  contentLoadingDefault: "#ffffff0d",
  contentLoadingInverse: "#0a0a0a0d",
  contentLink: "#64AEFF",
  contentLinkActive: "#0070EB",
  backgroundBase: "#0a0a0a",
  backgroundSurface: "#1C1D1D",
  backgroundLayer: "#2B2D2E",
  backgroundAccent: "#ffffff0d",
  backgroundHover: "#3C3E40",
  backgroundDisabled: "#3C3E40",
  backgroundTransparent: "#0a0a0a00",
  backgroundSecondary: "#0a0a0a",
  backgroundBrand: "#2B90FF",
  backgroundGradientSurfaceFadeEnd: "linear-gradient(90deg, #0a0a0a00 0%, #1C1D1D 100%)",
  backgroundGradientSurfaceFadeBottom: "linear-gradient(180deg, #0a0a0a00 0%, #1C1D1D 100%)",
  backgroundGradientColorStopsStart: "#0a0a0a00",
  backgroundGradientColorStopsEnd: "#1C1D1D",
  borderDefault: "#6A6F73",
  borderSubtle: "#4D5153",
  borderActive: "#64AEFF",
  borderDisabled: "#ffffff1a",
  borderInverse: "#EAF0F6",
  borderBrand: "#2B90FF",
  linkDefaultBase: "#64AEFF",
  linkDefaultHover: "#0070EB",
  linkDestructiveBase: "#EA6875",
  linkDestructiveHover: "#D22839",
  systemInfoBackgroundDefault: "#004EA3",
  systemInfoBackgroundSubtle: "#002650",
  systemInfoBorderDefault: "#004EA3",
  systemInfoContentOnSubtle: "#ffffff",
  systemInfoContentAccent: "#99CAFF",
  systemInfoLinkOnSubtle: "#ffffff",
  systemPositiveBackgroundDefault: "#005D23",
  systemPositiveBackgroundSubtle: "#002E11",
  systemPositiveBorderDefault: "#005D23",
  systemPositiveContentOnSubtle: "#ffffff",
  systemPositiveContentAccent: "#7FD9A1",
  systemPositiveLinkOnSubtle: "#ffffff",
  systemAlertBackgroundDefault: "#756100",
  systemAlertBackgroundSubtle: "#4B3F00",
  systemAlertBorderDefault: "#756100",
  systemAlertContentOnDefault: "#ffffff",
  systemAlertContentOnSubtle: "#ffffff",
  systemAlertContentAccent: "#FFDC2E",
  systemAlertLinkOnDefault: "#ffffff",
  systemAlertLinkOnSubtle: "#ffffff",
  systemWarningBackgroundDefault: "#A44800",
  systemWarningBackgroundSubtle: "#692E00",
  systemWarningBorderDefault: "#A44800",
  systemWarningContentOnDefault: "#ffffff",
  systemWarningContentOnSubtle: "#ffffff",
  systemWarningContentAccent: "#FFB77E",
  systemWarningLinkOnDefault: "#ffffff",
  systemWarningLinkOnSubtle: "#ffffff",
  systemImportantBackgroundDefault: "#A40023",
  systemImportantBackgroundSubtle: "#40020D",
  systemImportantBorderDefault: "#A40023",
  systemImportantContentOnSubtle: "#ffffff",
  systemImportantContentAccent: "#F198A1",
  systemImportantLinkOnSubtle: "#ffffff",
  systemNeutralBackgroundDefault: "#6A6F73",
  systemNeutralBackgroundSubtle: "#2B2D2E",
  systemNeutralBorderDefault: "#6A6F73",
  systemNeutralContentOnDefault: "#ffffff",
  systemNeutralContentOnSubtle: "#ffffff",
  systemNeutralContentAccent: "#CED4DB",
  systemNeutralLinkOnDefault: "#ffffff",
  systemNeutralLinkOnSubtle: "#ffffff",
  systemVerificationBackgroundDefault: "#61019B",
  systemVerificationBackgroundSubtle: "#36005B",
  systemVerificationBorderDefault: "#61019B",
  systemVerificationContentOnSubtle: "#ffffff",
  systemVerificationContentAccent: "#D4B6FE",
  systemVerificationLinkOnSubtle: "#ffffff",
  componentButtonPrimaryContentDisabled: "#ffffff33",
  componentButtonPrimaryBackgroundDisabled: "#3C3E40",
  componentButtonPrimaryBorderDisabled: "#ffffff1a",
  componentButtonSecondaryContentDisabled: "#ffffff33",
  componentButtonSecondaryBackgroundDisabled: "#3C3E40",
  componentButtonSecondaryBorderDisabled: "#ffffff1a",
  componentButtonTertiaryContentBase: "#64AEFF",
  componentButtonTertiaryContentHover: "#2B90FF",
  componentButtonTertiaryContentDisabled: "#ffffff33",
  componentButtonTertiaryBackgroundBase: "#0a0a0a00",
  componentButtonTertiaryBackgroundHover: "#002650",
  componentButtonTertiaryBackgroundActive: "#005FC8",
  componentButtonTertiaryBackgroundDisabled: "#0a0a0a00",
  componentButtonTertiaryBorderBase: "#64AEFF",
  componentButtonTertiaryBorderHover: "#2B90FF",
  componentButtonTertiaryBorderActive: "#005FC8",
  componentButtonTertiaryBorderDisabled: "#ffffff1a",
  componentButtonTransparentContentDisabled: "#ffffff33",
  componentButtonTransparentBackgroundBase: "#0a0a0a00",
  componentButtonTransparentBackgroundActive: "#005FC8",
  componentButtonTransparentBackgroundDisabled: "#0a0a0a00",
  componentButtonTransparentBorderActive: "#0a0a0a00",
  componentButtonTransparentBorderDisabled: "#ffffff1a",
  componentButtonDestructiveContentDisabled: "#ffffff33",
  componentButtonDestructiveBackgroundHover: "#A40023",
  componentButtonDestructiveBackgroundActive: "#83001C",
  componentButtonDestructiveBackgroundDisabled: "#3C3E40",
  componentButtonDestructiveBorderHover: "#A40023",
  componentButtonDestructiveBorderActive: "#83001C",
  componentButtonDestructiveBorderDisabled: "#ffffff1a",
  componentButtonButtonLinkContentBase: "#64AEFF",
  componentButtonButtonLinkContentHover: "#0070EB",
  componentButtonButtonLinkContentDisabled: "#3C3E40",
  componentButtonButtonLinkBackgroundBase: "#0a0a0a00",
  componentButtonButtonLinkBackgroundHover: "#002650",
  componentButtonButtonLinkBackgroundDisabled: "#0a0a0a00",
  componentButtonButtonLinkBorderBase: "#0a0a0a00",
  componentButtonButtonLinkBorderHover: "#0a0a0a00",
  componentButtonButtonLinkBorderActive: "#0a0a0a00",
  componentButtonButtonLinkBorderDisabled: "#ffffff1a",
  componentSelectionControlBackgroundBase: "#1C1D1D",
  componentSelectionControlBackgroundHover: "#002650",
  componentSelectionControlBackgroundActive: "#2B90FF",
  componentSelectionControlBackgroundSelected: "#64AEFF",
  componentSelectionControlBackgroundSelectedHover: "#99CAFF",
  componentSelectionControlBackgroundSelectedActive: "#99CAFF",
  componentSelectionControlBackgroundUnselected: "#4D5153",
  componentSelectionControlBackgroundDisabled: "#3C3E40",
  componentSelectionControlBackgroundSuccess: "#31C268",
  componentSelectionControlBackgroundError: "#EA6875",
  componentSelectionControlBorderBase: "#6A6F73",
  componentSelectionControlBorderHover: "#64AEFF",
  componentSelectionControlBorderActive: "#64AEFF",
  componentSelectionControlBorderSelected: "#64AEFF",
  componentSelectionControlBorderSelectedHover: "#99CAFF",
  componentSelectionControlBorderSelectedActive: "#99CAFF",
  componentSelectionControlBorderUnselected: "#4D5153",
  componentSelectionControlBorderDisabled: "#ffffff1a",
  componentSelectionControlBorderSuccess: "#1BB152",
  componentSelectionControlBorderError: "#EB4758",
  componentSelectionControlForegroundBase: "#0a0a0a00",
  componentSelectionControlForegroundHover: "#0a0a0a00",
  componentSelectionControlForegroundActive: "#0a0a0a00",
  componentSelectionControlForegroundSelected: "#011638",
  componentSelectionControlForegroundSelectedHover: "#011638",
  componentSelectionControlForegroundSelectedActive: "#011638",
  componentSelectionControlForegroundUnselected: "#0a0a0a00",
  componentSelectionControlForegroundDisabled: "#ffffff33",
  componentSelectionControlForegroundSuccess: "#011638",
  componentSelectionControlForegroundError: "#011638",
  componentDataInputBackgroundBase: "#1C1D1D",
  componentDataInputBackgroundLayer: "#2B2D2E",
  componentDataInputBackgroundHover: "#3C3E40",
  componentDataInputBackgroundError: "#40020D",
  componentDataInputBackgroundDisabled: "#3C3E40",
  componentDataInputBorderBase: "#6A6F73",
  componentDataInputBorderActive: "#004EA3",
  componentDataInputBorderError: "#A40023",
  componentDataInputBorderDisabled: "#ffffff1a",
  componentDataInputContentBase: "#CED4DB",
  componentDataInputContentSubtle: "#969DA3",
  componentDataInputContentHover: "#99CAFF",
  componentDataInputContentError: "#F198A1",
  componentDataInputContentDisabled: "#ffffff33",
  componentDataInputLabelBase: "#ffffff",
  componentDataInputLabelActive: "#99CAFF",
  componentDataInputLabelError: "#F198A1",
  componentDataInputLabelDisabled: "#ffffff33",
  componentDataInputPasswordMeterEmpty: "#6A6F73",
  componentDataInputPasswordMeterWeak: "#A40023",
  componentDataInputPasswordMeterFair: "#A44800",
  componentDataInputPasswordMeterGood: "#004EA3",
  componentDataInputPasswordMeterGreat: "#005D23",
  componentDataInputIconBase: "#969DA3",
  componentDataInputIconActive: "#99CAFF",
  componentDataInputIconError: "#F198A1",
  componentDataInputIconDisabled: "#ffffff33",
  componentPillPrimaryContentBase: "#ffffff",
  componentPillPrimaryContentHover: "#ffffff",
  componentPillPrimaryContentSelected: "#011638",
  componentPillPrimaryContentActive: "#011638",
  componentPillPrimaryContentDisabled: "#0a0a0a",
  componentPillPrimaryBackgroundBase: "#ffffff1a",
  componentPillPrimaryBackgroundHover: "#ffffff4d",
  componentPillPrimaryBackgroundSelected: "#64AEFF",
  componentPillPrimaryBackgroundActive: "#2B90FF",
  componentPillPrimaryBackgroundDisabled: "#2B2D2E",
  componentPillInverseContentHover: "#ffffff",
  componentPillInverseContentSelected: "#011638",
  componentPillInverseContentActive: "#011638",
  componentPillInverseContentDisabled: "#0a0a0a",
  componentPillInverseBackgroundBase: "#0a0a0a00",
  componentPillInverseBackgroundHover: "#ffffff4d",
  componentPillInverseBackgroundSelected: "#64AEFF",
  componentPillInverseBackgroundActive: "#2B90FF",
  componentPillInverseBackgroundDisabled: "#2B2D2E",
};

export const text = {
  themeName: "Fanduel Dark",
};